var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFourthStep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 250",
    style: {
      enableBackground: "new 0 0 320 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.2746,
    y1: 39.1239,
    x2: 158.7875,
    y2: 253.2636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#69CAF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B89E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M292.524,0H28.214C13.683,0,2.285,11.849,2.752,26.387L9.163,225.8 c0.428,13.302,11.955,24.031,25.749,24.031h250.914c13.794,0,25.322-10.728,25.749-24.031l6.411-199.413 C318.453,11.849,307.055,0,292.524,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#0E92C2",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M67.985,36.74l2.478,147.237l91.332-2.102 l4.337-142.124c0,0-16.913,2.928-51.552,0.992C87.36,39.222,67.985,36.74,67.985,36.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#33C0F1",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M76.579,44.175l2.478,147.237l91.332-2.102 l4.337-142.124c0,0-16.913,2.928-51.552,0.992C95.954,46.657,76.579,44.175,76.579,44.175z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9AE1F8"
    },
    points: "88.724,58.724 90.211,91.208 125.707,91.208 124.414,59.801 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.017,
    y: 96.975,
    style: {
      fill: "#9AE1F8"
    },
    width: 79.144,
    height: 2.527
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.017,
    y: 102.581,
    style: {
      fill: "#9AE1F8"
    },
    width: 79.144,
    height: 2.527
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#33C0F1"
    },
    cx: 106.879,
    cy: 71.426,
    r: 6.01
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#33C0F1"
    },
    d: "M118.887,88.631c-1.409-5.11-6.079-8.867-11.636-8.867c-5.558,0-10.227,3.758-11.636,8.867H118.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E92C2"
    },
    d: "M97.309,121.14H90.92c-1.213,0-2.196-0.983-2.196-2.196v-5.604c0-1.213,0.983-2.196,2.196-2.196 h6.389c1.213,0,2.196,0.983,2.196,2.196v5.604C99.505,120.156,98.522,121.14,97.309,121.14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.231,
    y: 114.489,
    style: {
      fill: "#9AE1F8"
    },
    width: 19.952,
    height: 2.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.493,
    y: 133.222,
    style: {
      fill: "#9AE1F8"
    },
    width: 57.411,
    height: 2.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.493,
    y: 147.385,
    style: {
      fill: "#9AE1F8"
    },
    width: 57.411,
    height: 2.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.493,
    y: 161.547,
    style: {
      fill: "#9AE1F8"
    },
    width: 57.411,
    height: 2.355
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.493,
    y: 175.71,
    style: {
      fill: "#9AE1F8"
    },
    width: 57.411,
    height: 2.355
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9537D"
    },
    d: "M147.464,161.952l0.627,26.798c0.134,5.726,4.77,10.323,10.497,10.408l78.18,1.168 c6.046,0.09,10.956-4.861,10.815-10.906l-0.733-31.434L147.464,161.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10,
      strokeDasharray: 3
    },
    d: "M151.181,157.986v29.828 c0,4.532,3.66,8.214,8.193,8.239l77.176,0.439c4.658,0.027,8.411-3.81,8.283-8.466l-0.957-34.822"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE7598"
    },
    d: "M146.968,131.976c-2.478,0.991-2.231,29.356-1.487,30.843c0.744,1.487,49.074,11.897,55.27,11.649 c6.196-0.248,46.843-6.692,48.578-9.17s-0.991-32.964-3.47-33.211C243.38,131.839,146.968,131.976,146.968,131.976z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.208,
    y: 117.794,
    style: {
      fill: "#E53666"
    },
    width: 3.47,
    height: 13.853
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.727,
    y: 117.794,
    style: {
      fill: "#E53666"
    },
    width: 3.47,
    height: 13.853
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.582,
    y: 129.073,
    style: {
      fill: "#E53666"
    },
    width: 12.144,
    height: 2.865
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.389,
    y: 129.073,
    style: {
      fill: "#E53666"
    },
    width: 12.144,
    height: 2.865
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE7598"
    },
    d: "M172.909,121.594c0.788,1.183,47.245,0.661,48.236-0.826c0.991-1.487,0.012-10.41-2.302-11.236 s-34.533,0.661-39.325,2.148C174.727,113.167,169.935,117.133,172.909,121.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10,
      strokeDasharray: 3
    },
    d: "M149.809,134.974 c-2.339,0.851-2.105,25.211-1.403,26.488c0.702,1.277,46.31,10.217,52.157,10.004c5.847-0.213,44.205-5.747,45.842-7.876 c1.637-2.129-0.936-28.309-3.274-28.522C240.792,134.856,149.809,134.974,149.809,134.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E53666"
    },
    d: "M186.968,164.228l1.191,12.016c0.16,1.618,1.521,2.85,3.147,2.85h13.412 c1.637,0,3.003-1.249,3.15-2.879l1.083-12.016c0.167-1.851-1.291-3.446-3.15-3.446h-15.686 C188.245,160.754,186.783,162.368,186.968,164.228z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.767,
    y: 60.575,
    style: {
      fill: "#9AE1F8"
    },
    width: 35.69,
    height: 2.527
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.767,
    y: 65.966,
    style: {
      fill: "#9AE1F8"
    },
    width: 35.69,
    height: 2.527
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.767,
    y: 71.358,
    style: {
      fill: "#9AE1F8"
    },
    width: 35.69,
    height: 2.527
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9537D"
    },
    d: "M229.591,57.153c-0.509-0.011-0.996,0.082-1.442,0.259l-2.595-6.543 c0.429-0.171,0.835-0.421,1.189-0.761c1.474-1.413,1.523-3.753,0.111-5.227s-3.753-1.523-5.227-0.111 c-0.361,0.346-0.633,0.748-0.823,1.179l-6.467-2.794c0.176-0.418,0.284-0.872,0.294-1.353c0.043-2.041-1.576-3.731-3.617-3.774 c-2.041-0.043-3.731,1.576-3.774,3.617c-0.011,0.505,0.082,0.988,0.256,1.43l-6.546,2.596c-0.171-0.425-0.419-0.827-0.755-1.178 c-1.413-1.474-3.753-1.523-5.227-0.111c-1.474,1.413-1.523,3.753-0.111,5.227c0.361,0.377,0.785,0.658,1.237,0.848l-2.792,6.462 c-0.434-0.191-0.91-0.304-1.414-0.315c-2.041-0.043-3.731,1.576-3.774,3.617c-0.043,2.041,1.577,3.731,3.618,3.774 c0.542,0.011,1.055-0.101,1.523-0.3l2.598,6.55c-0.461,0.171-0.896,0.433-1.273,0.795c-1.474,1.413-1.523,3.753-0.111,5.227 c1.413,1.474,3.753,1.523,5.227,0.111c0.398-0.382,0.683-0.834,0.873-1.315l6.474,2.797c-0.212,0.453-0.34,0.954-0.352,1.486 c-0.043,2.041,1.576,3.731,3.617,3.774c2.041,0.043,3.731-1.576,3.774-3.618c0.012-0.546-0.103-1.063-0.306-1.534l6.553-2.599 c0.17,0.465,0.434,0.904,0.798,1.285c1.413,1.474,3.753,1.523,5.227,0.111c1.474-1.413,1.523-3.753,0.111-5.227 c-0.366-0.382-0.795-0.663-1.254-0.853l2.792-6.462c0.438,0.196,0.921,0.309,1.43,0.32c2.041,0.043,3.731-1.576,3.774-3.617 C233.251,58.886,231.632,57.197,229.591,57.153z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 210.582,
    cy: 61.119,
    r: 6.111
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M200.848,68.18 c-1.441-1.983-2.29-4.423-2.29-7.061c0-6.641,5.383-12.024,12.024-12.024s12.024,5.383,12.024,12.024s-5.383,12.024-12.024,12.024"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M238.718,55.008 c0.105,0.487,0.198,0.978,0.278,1.474"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeMiterlimit: 10,
      strokeDasharray: "2.9808,2.9808"
    },
    d: " M239.32,59.444c0.032,0.554,0.048,1.113,0.048,1.675c0,15.898-12.888,28.787-28.787,28.787s-28.787-12.888-28.787-28.787 s12.888-28.787,28.787-28.787c5.655,0,10.929,1.631,15.378,4.447"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M227.198,37.61 c0.408,0.289,0.808,0.588,1.201,0.898"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9537D"
    },
    d: "M187.162,79.212c-0.355-0.057-0.705-0.039-1.034,0.041l-1.179-4.83 c0.317-0.078,0.625-0.213,0.906-0.416c1.169-0.845,1.431-2.477,0.586-3.646s-2.477-1.431-3.646-0.586 c-0.286,0.207-0.516,0.462-0.69,0.744l-4.252-2.584c0.164-0.275,0.284-0.582,0.338-0.918c0.229-1.424-0.74-2.764-2.164-2.992 c-1.424-0.229-2.764,0.74-2.992,2.164c-0.057,0.352-0.039,0.699,0.04,1.025l-4.832,1.179c-0.078-0.314-0.212-0.619-0.414-0.898 c-0.845-1.169-2.477-1.431-3.646-0.586c-1.169,0.845-1.431,2.477-0.586,3.646c0.216,0.299,0.485,0.537,0.783,0.714l-2.582,4.249 c-0.285-0.176-0.607-0.301-0.958-0.358c-1.424-0.229-2.764,0.74-2.992,2.164c-0.229,1.424,0.74,2.764,2.164,2.992 c0.378,0.061,0.748,0.032,1.095-0.062l1.18,4.835c-0.339,0.075-0.669,0.216-0.968,0.432c-1.169,0.845-1.431,2.477-0.586,3.646 s2.477,1.431,3.646,0.586c0.316-0.228,0.559-0.517,0.739-0.835l4.257,2.587c-0.193,0.296-0.331,0.634-0.391,1.006 c-0.229,1.424,0.74,2.764,2.164,2.992c1.424,0.229,2.764-0.74,2.992-2.164c0.061-0.381,0.031-0.754-0.065-1.103l4.837-1.18 c0.074,0.342,0.215,0.675,0.433,0.977c0.845,1.169,2.477,1.431,3.646,0.586s1.431-2.477,0.586-3.646 c-0.219-0.303-0.492-0.541-0.794-0.719l2.582-4.249c0.287,0.18,0.614,0.306,0.969,0.363c1.424,0.229,2.764-0.74,2.992-2.164 C189.555,80.78,188.586,79.44,187.162,79.212z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 173.478,
    cy: 80.136,
    r: 4.316
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M165.981,84.129 c-0.815-1.527-1.172-3.317-0.915-5.163c0.646-4.646,4.936-7.888,9.582-7.242c4.646,0.646,7.888,4.936,7.242,9.582 c-0.646,4.646-4.936,7.888-9.582,7.242"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M193.757,78.599 c0.037,0.496,0.056,0.996,0.056,1.499"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeMiterlimit: 10,
      strokeDasharray: "2.9921,2.9921"
    },
    d: " M193.597,83.081c-1.615,11.046-11.845,18.735-22.92,17.195c-11.123-1.547-18.885-11.818-17.338-22.941 c1.547-11.123,11.818-18.885,22.941-17.338c3.644,0.507,6.927,1.95,9.64,4.052"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: "M187.066,65.008 c0.372,0.335,0.731,0.683,1.077,1.043"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E92C2"
    },
    d: "M137.216,121.14h-6.389c-1.213,0-2.196-0.983-2.196-2.196v-5.604c0-1.213,0.983-2.196,2.196-2.196 h6.389c1.213,0,2.196,0.983,2.196,2.196v5.604C139.412,120.156,138.429,121.14,137.216,121.14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.164,
    y: 114.489,
    style: {
      fill: "#9AE1F8"
    },
    width: 19.952,
    height: 2.355
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFEBFA",
      stroke: "#93C4CD",
      strokeMiterlimit: 10
    },
    d: "M99.594,138.448h-7.034c-0.704,0-1.275-0.571-1.275-1.275V130.8 c0-0.704,0.571-1.275,1.275-1.275h7.034c0.704,0,1.275,0.571,1.275,1.275v6.373C100.868,137.877,100.298,138.448,99.594,138.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFEBFA",
      stroke: "#93C4CD",
      strokeMiterlimit: 10
    },
    d: "M99.594,153.023h-7.034c-0.704,0-1.275-0.571-1.275-1.275 v-6.373c0-0.704,0.571-1.275,1.275-1.275h7.034c0.704,0,1.275,0.571,1.275,1.275v6.373 C100.868,152.453,100.298,153.023,99.594,153.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFEBFA",
      stroke: "#93C4CD",
      strokeMiterlimit: 10
    },
    d: "M99.594,167.599h-7.034c-0.704,0-1.275-0.571-1.275-1.275 v-6.373c0-0.704,0.571-1.275,1.275-1.275h7.034c0.704,0,1.275,0.571,1.275,1.275v6.373 C100.868,167.028,100.298,167.599,99.594,167.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFEBFA",
      stroke: "#93C4CD",
      strokeMiterlimit: 10
    },
    d: "M99.594,182.174h-7.034c-0.704,0-1.275-0.571-1.275-1.275 v-6.373c0-0.704,0.571-1.275,1.275-1.275h7.034c0.704,0,1.275,0.571,1.275,1.275v6.373 C100.868,181.604,100.298,182.174,99.594,182.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M188.115,112.259 c0,0-7.853,0.413-11.24,2.644c-3.387,2.231-3.194,4.075-3.194,4.075"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#33C0F1",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 93.867,133.222 96.077,136.424 100.868,127.997 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#33C0F1",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 93.867,148.103 96.077,151.304 100.868,142.878 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#33C0F1",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 93.867,162.559 96.077,165.761 100.868,157.334 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#33C0F1",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 93.867,177.156 96.077,180.357 100.868,171.931 "
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourthStep);
export default __webpack_public_path__ + "static/media/fourth_step.db7fed58d23aa6bdf5709d407a34cef2.svg";
export { ForwardRef as ReactComponent };